import { render, staticRenderFns } from "./disclaimer_new.vue?vue&type=template&id=1b115258&scoped=true&"
import script from "./disclaimer_new.vue?vue&type=script&lang=js&"
export * from "./disclaimer_new.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer_new.vue?vue&type=style&index=0&id=1b115258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b115258",
  null
  
)

export default component.exports